<template>
  <div class="fee-breakdown-block unit-group">
    <div class="unit-group__head">
      <h3 class="unit-group__head-title">{{ groupTitle }}</h3>
      <span class="unit-group__head-helptip" v-if="getTooltip()" :id="`tooltip-${ getTooltip() }`"><i class="fal fa-info-circle"></i></span>
    </div>
    <div class="unit-group__body">
      <!-- If Container show containers -->
      <!-- If Subgroup show subgroups -->
      <!-- If units show unit table -->

      <template v-if="containers && containers.length">
        <FeeUnitContainer v-for="(con,index) in containers" :key="index"
          :container="con"
          :location="getContainerLocation(con)"
          :seenUnits="seenUnits" />
      </template>

      <template v-else>
        <template v-if="relationships && relationships.length">
          <FeeUnitContainer :container="container" :location="location" :seenUnits="seenUnits" />
        </template>
      </template>

    </div>

    <b-tooltip v-if="getTooltip()" :target="`tooltip-${ getTooltip() }`" triggers="hover focus" placement="right">
      {{ __(`label:${ getTooltip() } tooltip`) }}
    </b-tooltip>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { dynamicSort } from 'common/helpers/dynamic-sort.js'
import SelectionLocationHelper from 'client/js/utils/selection-location-helper.js'

import FeeUnitContainer from './FeeUnitContainer.vue'
import FeeUnitSubGroup from './FeeUnitSubGroup.vue'

export default {
  props: {
    groupTitle: {
      type: String,
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    seenUnits: {
      type: Array,
      required: true
    }
  },
  methods: {
    // __:i18n,
    getContainerLocation(container) {
      return SelectionLocationHelper.getContainerLocation(this.location, container)
    },
    getTooltip() {
      if (this.groupTitle.toLowerCase().trim().includes('spine')) {
        return 'spine'
      }
      if (this.groupTitle.toLowerCase().trim().includes('core')) {
        return 'core'
      }
      if (this.groupTitle.toLowerCase().trim().includes('major')) {
        return 'major'
      }
      if (this.groupTitle.toLowerCase().trim().includes('option')) {
        return 'option'
      }
      return false
    }
  },
  computed: {
    ...mapGetters({
      totalCredits: 'units/getTotalCredits'
    }),
    credits() {
      return this.totalCredits(this.location, false)
    },
    maxCredits() {
      return parseInt(this.container.credits) || 0
    },
    containers: function () {
      return this.container.container.slice().sort(dynamicSort('order'))
    },
    relationships: function () {
      return this.container.relationship.slice().sort(dynamicSort('order'))
    }
  },
  components: { FeeUnitContainer, FeeUnitSubGroup }
}
</script>
